module.exports = __webpack_public_path__ + "img/2022081211004329641y.232e045b.jpg";